import React from 'react'
import fondo from '../img/fondo.PNG'

function BackGround() {
  return (
<div style={{ 
  backgroundImage: `url(${fondo})`,
  backgroundRepeat: 'no-repeat',
  width:'250px' 
}}>
    aaaaaaaaaaaaaaa
    </div>
  )
}

export default BackGround

